import { App, createApp, reactive } from 'vue';
// import KkToast from './index';
import KkToastProvider from './kk-toast-provider.vue';
import { injectKey, KKToastProps, KKToastInnerProps } from './typings';

// 缓存App实例
let toastApp: App<Element> | null = null;

let id = 0;
function genKey(): string {
  id = id + 1;
  return `kk-toast__${id}`;
}

const messages = reactive<KKToastInnerProps[]>([]);

const DEFAULT_PROPS: KKToastProps = {
  duration: 3000,
  content: '',
  type: 'success',
};

export function showToast(params: KKToastProps | string) {
  if (!toastApp) {
    toastApp = createApp(KkToastProvider, {
      messages,
    });
    const el = document.createElement('div');
    toastApp.mount(el);
  }

  const key = genKey();

  const message: KKToastInnerProps = typeof params === 'string' ? {
    ...DEFAULT_PROPS,
    content: params,
    key,
  } : {
    ...DEFAULT_PROPS,
    key,
    ...params,
  };

  messages.push(message);

  setTimeout(() => {
    const keyIdx = messages.findIndex(item => item.key === key);
    if (keyIdx > -1) {
      messages.splice(keyIdx, 1);
    }
  }, message.duration);

  return {
    key,
  };
}

export default function install(app: App) {
  // 使用provide注入，用于setup场景使用
  app.provide(injectKey, showToast);

  // 在component组件方式使用
  // eslint-disable-next-line no-param-reassign
  app.config.globalProperties.$toast = showToast;
}
